import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

import { BaseComponent } from '../base/base-component.component';
import { HelperService } from '../services/helper.service';

export enum SearchInputType {
  Regular = 0,
  Expandable = 1,
}

@Component({
  standalone: false,
  selector: 'daui-search-input',
  templateUrl: './search-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./search-input.component.less'],
})
export class SearchInputComponent extends BaseComponent {
  @Input() set text(text: string) {
    if (text === undefined) {
      text = '';
    }
    this.currentTextSearch = text;
  }
  @Input() placeholder: string;
  @Input() type = SearchInputType.Regular;
  @Input() isMultiSearch = SearchInputType.Regular;
  @Input() debounceTime = 800;
  @Input() autocomplete = 'off';
  @Output() textChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() clear: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('input', { static: false })
  private input: ElementRef;

  @ViewChild('InputNoPlaceholder', { static: false })
  private inputNoPlaceholder: ElementRef;

  @ViewChild('InputPlaceholder', { static: false })
  private inputPlaceholder: ElementRef;
  @HostListener('click')
  clickInside() {
    this.isClickInside = true;
  }
  @HostListener('document:click')
  clickout() {
    if (!this.isClickInside) {
      if (
        this.type === SearchInputType.Expandable &&
        this.isExpanded &&
        this.helperService.isNullOrEmpty(this.currentTextSearch.trim())
      ) {
        this.isExpanded = false;
      }
    }
    this.isClickInside = false;
  }

  emitTimer: ReturnType<typeof setTimeout>;
  currentTextSearch = '';
  oldTextSearch = '';
  isExpanded = false;
  isCollapsingArmed = false;
  isClickInside = false;

  readonly searchInputType = SearchInputType;

  constructor(private helperService: HelperService) {
    super();
  }

  protected onInit(): void {}
  protected onDestroy(): void {}

  onSearch() {
    if (this.emitTimer) {
      clearTimeout(this.emitTimer);
    }

    this.emitTextChange();
    if (this.isMultiSearch && this.type === SearchInputType.Regular) {
      this.currentTextSearch = '';
      this.oldTextSearch = '';
    }
  }

  onSearchToggle() {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      if (this.placeholder) {
        this.inputPlaceholder.nativeElement.focus();
      } else {
        this.inputNoPlaceholder.nativeElement.focus();
      }
    }
    this.clearText();
  }

  onClearText() {
    this.clearText();
  }

  clearText() {
    this.currentTextSearch = '';
    this.clear.emit();
    this.emitTextChange();
  }

  textChanged(_event: Event) {
    if (!this.isMultiSearch && this.debounceTime) {
      clearTimeout(this.emitTimer);

      let typingTimerDuration = this.debounceTime;

      if (this.helperService.isNullOrEmpty(this.currentTextSearch.trim())) {
        typingTimerDuration = this.debounceTime - 200;
      }
      this.emitTimer = setTimeout(() => {
        this.emitTextChange();
      }, typingTimerDuration);
    }
  }
  emitTextChange() {
    if (this.helperService.isNullOrEmpty(this.currentTextSearch.trim())) {
      this.currentTextSearch = this.currentTextSearch.trim();
    }

    if (this.oldTextSearch === this.currentTextSearch) {
      return;
    }
    this.oldTextSearch = this.currentTextSearch;
    this.textChange.emit(this.currentTextSearch);
  }
  focus() {
    this.input.nativeElement.focus();
  }
  onMouseoverSearch() {
    if (!this.isExpanded) {
      this.onSearchToggle();
    }
  }
}
